import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as Providers from 'providers/components';
import ProvidersListHandlers from 'providers/containers/ProvidersListHandlers';
import ProvidersRowContainer from 'providers/containers/ProvidersRowContainer';

import { getCompany, getSubcompany, getPermissions } from 'auth/selectors';
import {
  getPagination,
  getFilters,
  getVisibleProviders,
  getIsLoading,
  getNeedFetch,
} from 'providers/selectors';
import { toggleProvider } from 'providers/actions';
import { addGrowlError as error, addGrowlSuccess as success } from 'messages/actions';

class ProvidersListContainer extends PureComponent {
  static propTypes = {
    company: PropTypes.object.isRequired,
    subcompany: PropTypes.object.isRequired,
    pagination: PropTypes.object.isRequired,
    filters: PropTypes.object.isRequired,
    permissions: PropTypes.object.isRequired,
  };

  handleToggle = (id) =>
    this.props
      .toggleProvider(id, this.props.company.id, this.props.subcompany.id)
      .then(({ value }) => this.props.success(value.message))
      .catch((err) => this.props.error(err.message));

  render = () => (
    <ProvidersListHandlers
      render={({
        handleOrderChange,
        handleLimitChange,
        handlePageChange,
        handleFiltersChange,
        handleSubmit,
        columnSearch, // Cambiar por redux
        handleToggleSearch, // Agregar
      }) => (
        <Providers.ListView
          count={this.props.providers.length}
          filters={this.props.filters}
          company={this.props.company}
          isLoading={this.props.isLoading}
          handleToggle={this.handleToggle}
          handleOrderChange={handleOrderChange}
          handleSubmit={handleSubmit}
          handleFiltersChange={handleFiltersChange}
          handleLimitChange={handleLimitChange}
          handlePageChange={handlePageChange}
          handleToggleSearch={handleToggleSearch} // Agregar
          columnSearch={columnSearch} // Agregar - corregir por Redux
          subcompany={this.props.subcompany}
          pagination={this.props.pagination}
          permissions={this.props.permissions}
        >
          {this.props.providers.map((provider) => (
            <ProvidersRowContainer
              key={provider.id}
              provider={provider}
              handleToggle={this.handleToggle}
            />
          ))}
        </Providers.ListView>
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  subcompany: getSubcompany(state),
  pagination: getPagination(state),
  filters: getFilters(state),
  providers: getVisibleProviders(state),
  permissions: getPermissions(state),
  isLoading: getIsLoading(state),
  needFetch: getNeedFetch(state),
});
const mapDispatchToProps = { toggleProvider, error, success };

export default connect(mapStateToProps, mapDispatchToProps)(ProvidersListContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/providers/containers/ProvidersListContainer.js